import React from "react";
import { HelmetProvider } from "react-helmet-async";

import "./src/components/Form/styles/index.css";
import "./src/styles/styles.css";

export { wrapPageElement } from "./gatsby-shared";

export const wrapRootElement = ({ element }) => (
  <HelmetProvider>
    {element}
  </HelmetProvider>
);

// Osano (in strict mode or with auto-block) rewrites dynamically-injected
// <script type="osano/blocked"> on webpack chunks, which freezes client-side
// navigation. Marketing scripts don't carry data-webpack, so they remain
// gated by Osano consent. This only unblocks first-party webpack chunks.
export const onClientEntry = () => {
  if (typeof window === "undefined") return;

  const unblock = (node) => {
    if (
      node?.tagName === "SCRIPT" &&
      node.type === "osano/blocked" &&
      node.hasAttribute("data-webpack")
    ) {
      const fresh = document.createElement("script");
      for (const attr of node.attributes) {
        if (attr.name !== "type") fresh.setAttribute(attr.name, attr.value);
      }
      node.parentNode.replaceChild(fresh, node);
    }
  };

  new MutationObserver((muts) => {
    for (const m of muts) for (const n of m.addedNodes) unblock(n);
  }).observe(document.head, { childList: true, subtree: true });
};
